import React, { useState, useRef, useEffect } from 'react';
import { usePushSubscription } from 'server';
import { compose } from 'js/utils/ramda.util';
import { I18n } from 'js/components/common/I18n';
import { Button } from 'js/components/common/Button';
import { Loader } from 'js/components/common/Loader';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import { IDENTT } from './constants';
import { StatusIcon } from './components/StatusIcon';
import { useDynamicReducerSelector, withDynamicReducer } from './store';

import style from './Identt.scss';

export const IdenttBare = () => {
    const windowRef = useRef();
    const { playerTag } = useComponentConfig();
    const translate = useComponentTranslations();
    const [iframeSrc, setIframeSrc] = useState('');
    const [isUrlLoading, setIsUrlLoading] = useState(false);
    const [identtError, setIdenttError] = useState('');
    const { verificationStatus, haveCopyIDFax } = useDynamicReducerSelector();
    const getPlayerData = hooks.useGetPlayerData();
    const getVerificationStatus = hooks.useGetVerificationStatus();
    const openIdentt = hooks.useOpenIdentt({
        windowRef,
        setIframeSrc,
        setIdenttError,
        setIsUrlLoading
    });

    usePushSubscription(31133, () => (pushMessage) => {
        const changedTag = pushMessage?.data?.notification?.notificationPlayerTagChangeInfo?.tag;

        if (changedTag !== playerTag) {
            return;
        }

        windowRef.current?.close?.();

        if (iframeSrc) {
            setIframeSrc('');
        }

        getPlayerData();
        getVerificationStatus();
    });

    useEffect(() => {
        getVerificationStatus();
    }, [getVerificationStatus]);

    useEffect(() => {
        getPlayerData();
    }, [getPlayerData]);

    if (!verificationStatus || !haveCopyIDFax) {
        return <Loader />;
    }

    if (iframeSrc) {
        return (
            <iframe
                allow="camera"
                src={iframeSrc}
                className={style.iframe}
            />
        );
    }

    const { showVerifyButton, value: verificationStatusValue } = verificationStatus;

    return (
        <div className={`${style.container} identt-status-${verificationStatusValue}`}>
            <h3 className={style.title}>{translate('title')}</h3>
            {identtError && <ErrorMessage error={identtError} animate={true} />}
            <p className={style.description}>{translate('description')}</p>
            <div className={style.status}>
                <StatusIcon verificationStatus={verificationStatus} />
                <I18n t={translate} tKey={`status.${verificationStatusValue}`} />
            </div>
            {showVerifyButton && (
                <Button
                    onClick={openIdentt}
                    disabled={isUrlLoading}
                    className={`${style.button} identt-verify-btn`}
                >
                    {translate('button')}
                </Button>
            )}
        </div>
    );
};

export const Identt = compose(
    withComponent({ isForLoggedIn: true }),
    withDynamicReducer()
)(IdenttBare);

componentService.registerPageComponents({ [IDENTT]: Identt });
